import React from "react";

export default function Loading({ className = "", sizeClass = "h-24 w-24" }) {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className="relative">
        <div
          className={`${sizeClass} rounded-full border-t-8 border-b-8 border-gray-200`}
        />
        <div
          className={`absolute top-0 left-0 ${sizeClass} rounded-full border-t-8 border-b-8 border-customYellow animate-spin`}
        />
      </div>
    </div>
  );
}
